import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { qashqLogo2 } from '../assets/images';

function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const location = useLocation();

  const toggleNav = () => setIsNavOpen(!isNavOpen);
  const closeNav = () => setIsNavOpen(false);

  useEffect(() => {
    const handleScroll = () => setIsHeaderActive(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    closeNav();
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = isNavOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isNavOpen]);

  return (
    <header className={`header ${isHeaderActive ? 'active' : ''}`} data-header>
      <div className="header-bar">
        <div className="container header-inner">
          <div
            className={`overlay ${isNavOpen ? 'active' : ''}`}
            onClick={closeNav}
            data-overlay
            role="presentation"
          ></div>

          <Link to="/" className="brand-link" onClick={closeNav} aria-label="QASHQ home">
            <img src={qashqLogo2} alt="QASHQ Business and IT Consultants" className="brand-logo" />
            <span className="brand-wordmark">QASHQ</span>
          </Link>

          <nav
            className={`navbar ${isNavOpen ? 'active' : ''}`}
            data-navbar
            aria-label="Primary navigation"
          >
            <div className="navbar-top">
              <Link to="/" className="logo mobile-logo" onClick={closeNav}>
                QASHQ
              </Link>
              <button
                type="button"
                className="nav-close-btn"
                aria-label="Close Menu"
                onClick={closeNav}
                data-nav-close-btn
              >
                <ion-icon name="close-outline"></ion-icon>
              </button>
            </div>

            <ul className="navbar-list">
              <li className="navbar-item">
                <Link to="/" className="navbar-link" onClick={closeNav} data-navbar-link>
                  Home
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/about" className="navbar-link" onClick={closeNav} data-navbar-link>
                  About
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/services" className="navbar-link" onClick={closeNav} data-navbar-link>
                  Services
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/blog" className="navbar-link" onClick={closeNav} data-navbar-link>
                  Blog
                </Link>
              </li>
              <li className="navbar-item">
                <Link to="/contact" className="navbar-link" onClick={closeNav} data-navbar-link>
                  Contact
                </Link>
              </li>
            </ul>

            <div className="navbar-actions">
              <Link to="/contact" className="btn btn-secondary navbar-cta" onClick={closeNav}>
                Get a Free Consultation
              </Link>
            </div>
          </nav>

          <div className="header-actions">
            <Link
              to="/contact"
              className="btn btn-secondary header-cta-btn"
              aria-label="Get a free consultation"
            >
              <span className="header-cta-btn__text header-cta-btn__text--full">
                Get a Free Consultation
              </span>
              <span className="header-cta-btn__text header-cta-btn__text--md">Free Consultation</span>
              <ion-icon name="calendar-outline" className="header-cta-btn__icon" aria-hidden="true"></ion-icon>
            </Link>

            <button
              type="button"
              className="nav-open-btn"
              aria-label="Open Menu"
              aria-expanded={isNavOpen}
              onClick={toggleNav}
              data-nav-open-btn
            >
              <ion-icon name="menu-outline"></ion-icon>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
